import React, { Component } from "react";
import Modal from "../../components/Modal/modal";
import Link from "gatsby-link";

import Image from "components/Image";
import SignUp from "components/Buttons/SignUp";

class VideoPlain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      embedUrl: `https://www.youtube.com/embed/${
        this.props.youtubeVideoId
      }?rel=0&amp;showinfo=0`,
      shareUrl: `https://www.youtube.com/watch?v=${this.props.youtubeVideoId}`
    };
  }

  openModal = () => {
    console.log("Opening the video modal");
    this.setState({
      modal: true
    });
  };

  closeModal = () => {
    this.setState({
      modal: false
    });
  };

  renderModal() {
    if (this.state.modal) {
      console.log(`First render with video modal.. - ${this.state.embedUrl}`);
      return (
        <Modal close={this.closeModal}>
          <iframe
            width="100%"
            height="330"
            src={`${this.state.embedUrl}`}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </Modal>
      );
    }
    return null;
  }

  render() {
    return (
      <section>
        <Image
          src={`${this.props.previewImage}`}
          className="img-fluid"
          alt=""
          style={{
            maxWidth: this.props.maxWidth ? this.props.maxWidth : "500px",
            cursor: "pointer",
            marginBottom: "5px"
          }}
          onClick={this.openModal}
        />

        {this.renderModal()}
      </section>
    );
  }
}

export default VideoPlain;



// WEBPACK FOOTER //
// ./src/sections/layouts/videoPlain.js